import { css, CSSResult, html, LitElement, TemplateResult } from "lit";
import { Player } from "../models/player/Player";
import { property } from "lit/decorators.js";


class LoginForm extends LitElement {
    @property({ type: String })
    private username: string = "";

    @property({ type: String })
    private password: string = "";

    private errorMessage: string | undefined;

    private onChangeUsername(event: InputEvent): void {
        this.username = (event.target as HTMLInputElement).value;
    }

    private onChangePassword(event: InputEvent): void {
        this.password = (event.target as HTMLInputElement).value;
    }


    /*CSS**/
    public static styles:CSSResult = css`
   
   .error-message{
        color: red;
    }
   
    .login {
    color: green;
    margin: 3cm auto 0;
    font-size: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
   
   
   
   .loginForm{
    text-align: center;
    border: 2px solid green;
    padding: 20px; 
    border-radius: 10px; 
    width: 300px; 
    margin: auto; 
}

input{
    background-color: black;
    color: green;
    border: 2px solid green;
    border-radius: 10px;
    font-size: 1.5rem;

  
}
::placeholder{
    color: green;
}

 .buttonRedirect button{
    background-color: black;
    color: green;
    border: 2px solid green;
    border-radius: 10px;
    margin-top: 20px;
    margin-inline: 4px;
    font-size: 1.2rem;
    cursor: pointer;
 }
   `;
    
    /*HTML**/
    public render(): TemplateResult<1> {
        return html`
             <h4 class="login">
        <pre>
██╗      ██████╗  ██████╗ ██╗███╗   ██╗
██║     ██╔═══██╗██╔════╝ ██║████╗  ██║
██║     ██║   ██║██║  ███╗██║██╔██╗ ██║
██║     ██║   ██║██║   ██║██║██║╚██╗██║
███████╗╚██████╔╝╚██████╔╝██║██║ ╚████║
╚══════╝ ╚═════╝  ╚═════╝ ╚═╝╚═╝  ╚═══╝
                                       
        </pre>

             </h4>
            <div class="loginForm">
                <!--Input types are username and password-->
                <div class="input">
                    <label for="username">username:</label><br />
                    <input type="text" name="username" id="userInput" placeholder="Username" .value= ${this.username} @input= ${this.onChangeUsername} /><br />

                    <label for="password">password:</label><br />
                    <input type="password" name="password" id="passwordInput" placeholder="Password"  .value= ${this.password} @input= ${this.onChangePassword}/>
                </div>
                
                ${this.errorMessage ? html`<div class="error-message">${this.errorMessage}</div>` : ""}

                <!--Button types are loginButton and createAccountButton-->
                <div class="buttonRedirect">
                <button id="loginButton" @click = ${this.loginButton}>LOGIN</button>
                <a href="register.html"><button type="submit">CREATE ACCOUNT</button></a>
                
                </div>
    </div>>
        `;
    }

    private async loginButton(): Promise<void> {
        try {
            const player: Player = new Player(undefined, this.username, this.password, undefined, undefined);
            const loginResult: any = await player.checkLogin();
            console.log(loginResult);

            switch (loginResult.result) {
                case true:
                    console.log("Login successful!");
                    window.location.href = "home.html";
                    break;
                case false:
                    console.log("Login failed: ", loginResult.message);
                    this.errorMessage = "Incorrect username or password";
                    break;
                default:
                    console.error("Invalid response format from checkLogin:", loginResult);
                    this.errorMessage = "Can't login. Unexpected response format.";
            }
        } catch (error) {
            console.error("An error occurred during login:", error);
            this.errorMessage = "Can't login";
        } finally {
            this.requestUpdate();
        }
    }



}



customElements.define("login-form", LoginForm);